import Setup from './Setup';
import TheOpioidEpidemic from './TheOpioidEpidemic';
import MeetJason from './MeetJason';
import MeetCarrie from './MeetCarrie';
import MeetGail from './MeetGail';
import OpioidEpidemic2 from './OpioidEpidemic2';
import MakingHeadlines from './MakingHeadlines';
import SelfAssessment from './SelfAssessment';

export default {
  title: 'Engage',
  children: [
    Setup,
    TheOpioidEpidemic,
    MeetJason,
    MeetCarrie,
    MeetGail,
    OpioidEpidemic2,
    MakingHeadlines,
    SelfAssessment
  ]
};



// WEBPACK FOOTER //
// ./src/data/engage/index.js